import { Podcast } from "./Podcast";


/** 
 * Describes the fields that will be shown in for a Podcast in the creation form
 * @see Podcast
 */
export const AddPodcastFormTemplate = Object.freeze({
  sections: [
    {
      size: 7 / 12,
      compact: true,
      //Careful
      inputs: [Podcast.name,
      Podcast.visible_timestamp,
      Podcast.text
      ],
    },
  ],
});
